/**
 * SchedulerRoute
 * ──────────────────────────────────────────────────────────────────────
 * Route-boundary wrapper that splits the scheduler surface by app mode:
 *   - isDemo === true   → renders `LegacyEchoScheduler` (pre-backend-wired
 *                         demo UX; full fixtures, AI auto-fill, waitlist,
 *                         templates, analytics). No /api/* calls.
 *   - isDemo === false  → renders `EchoScheduler` (API-wired Today view +
 *                         empty-state placeholders for the other tabs).
 *
 * This is the single source of truth for how `/lumina/scheduler` (and the
 * legacy `/echo/scheduler` redirect) decides which surface to render.
 */
import { useAppMode } from '../../contexts/AppModeContext';
import { isDemoMode } from '../../lib/modeGuard';
import EchoScheduler from './EchoScheduler';
import LegacyEchoScheduler from './LegacyEchoScheduler';

const SchedulerRoute = () => {
  const { isDemo } = useAppMode();
  // Belt-and-braces: `useAppMode()` relies on the provider having processed
  // the latest `setDemoMode()` event. In the rare case it hasn't (e.g. an
  // immediate navigate() right after auth) fall back to a direct read
  // from localStorage via `isDemoMode()`. Either truthy answer wins —
  // the scheduler MUST render legacy whenever demo is configured.
  const demo = isDemo || isDemoMode();
  return demo
    ? <LegacyEchoScheduler />
    : <EchoScheduler />;
};

export default SchedulerRoute;
